const { m } = require('minthril');
const { Button } = require('../../button');
const { formatMoney } = require('../../../business');

function CartPage() {
  return {
    view: ({ attrs: { cart, onUpdate, onRemove, onCheckout } }) => m('section.cart-page',
      m('p.products__eyebrow', 'Your selection'),
      m('h1.products__heading', 'Cart'),
      !cart?.lines?.nodes?.length
        ? m('p.cart-page__empty', 'Your cart is currently empty.')
        : m('div.cart-page__content',
          m('div.cart-page__lines', cart.lines.nodes.map(line => {
            const product = line.merchandise?.product;
            const total = line.cost?.totalAmount;
            return m('article.cart-line', { key: line.id },
              product?.featuredImage ? m('img.cart-line__image', { src: product.featuredImage.url, alt: product.featuredImage.altText || product.title }) : null,
              m('div.cart-line__details',
                m('a.cart-line__title', { href: `/products/${product?.handle || ''}` }, product?.title || 'Product'),
                total ? m('p.cart-line__price', formatMoney(total.amount, total.currencyCode)) : null,
                m('div.cart-line__controls',
                  m('button', { type: 'button', onclick: () => onUpdate(line, line.quantity - 1), disabled: line.quantity <= 1 }, '−'),
                  m('span', line.quantity),
                  m('button', { type: 'button', onclick: () => onUpdate(line, line.quantity + 1) }, '+'),
                  m('button.cart-line__remove', { type: 'button', onclick: () => onRemove(line) }, 'Remove')
                )
              )
            );
          })),
          m('aside.cart-page__summary',
            m('p', `Subtotal ${formatMoney(cart.cost.subtotalAmount.amount, cart.cost.subtotalAmount.currencyCode)}`),
            m(Button, { disabled: !cart.totalQuantity, onclick: onCheckout }, 'Checkout')
          )
        )
    )
  };
}

module.exports = { CartPage };
